import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {Store} from '@ngxs/store';

@Component({
  selector: 'gg-loader',
  templateUrl: './loader.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoaderComponent implements OnInit {
  public percent$ = this.store.select(state => state.player.loading);
  public currentTime$ = this.store.select(state => state.player.timings.currentTime);

  constructor(private store: Store) {
  }

  ngOnInit() {
  }

}
